import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const ITR_UTM_REF = 'itr_2023_organic_landing_page_2';
const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const cryptoIntegrationLink = `${publicRuntimeConfig.SSO_ENDPOINT}?product=crypto&utm_ref=crypto_itr_2_integration_page&return_path=L2NyeXB0by10YXgtZmlsaW5nL2Jyb2tlcnMv`;

const heroSection = {
  title: 'File ITR for capital gains in minutes ',
  lists: [
    'Handle ESOPs, RSUs, and foreign stock options with ease',
    'Auto-calculates capital gains and applies FTAA/DTAA correctly',
    'Real-time one click integration with brokers',
  ],
  button: [
    {
      text: 'Start filing',
      url: startFilingLink,
    },
    {
      text: 'View plans',
    },
  ],
};

const whyChooseSection = {
  title: 'Full Clarity on Your Tax Liability —From Vesting to Filing',
  lists: [
    {
      title: 'Select your broker',
    },
    {
      title: 'Upload broker statement',
    },
    {
      title: 'Verify scheduled FSI and other income data',
    },
    {
      title: 'Finish filing',
    },
  ],
  buttons: [
    {
      text: 'Start FIling',
      url: startFilingLink,
    },
  ],
};
export const ExchangeList = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/718342aa-8b15-49d5-9d1a-45d1806e5c1e.png',
    name: 'Upstox',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/db2e54bb-de91-464e-8814-060c807fc7c3.png',
    name: 'Kite',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3bc8bfe5-ea83-404c-b41e-8f5ea8d633e8.png',
    name: 'Groww',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4b73f019-0e78-4e20-a1c8-4b0798130b54.png',
    name: 'ICICI Direct',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e8ce47b3-1f4c-48c8-aece-129ab4c098ff.png',
    name: 'Paytm Money',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/bb34b676-c260-4564-8789-353fa5cb6237.png',
    name: 'SBI Caps',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1a4f9afc-2d8e-4289-9190-04eed9f7a244.png',
    name: 'Kotak',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a965c566-85b4-4d76-b10a-687be311c652.png',
    name: 'Axis Securities',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/734b28d5-91cf-4d68-8382-82209468c896.png',
    name: 'Reliance Securities',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d37ab44c-70e2-493b-8bbc-eed9dcc53534.png',
    name: 'Zerodha',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5937fd37-48df-404b-be2e-ed89f99e3a12.png',
    name: 'HDFC Securities',
  },
];

export const ExchangeList2 = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108712_wazirx_logo.png',
    name: 'WazirX',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109419_coindcx_logo.png',
    name: 'CoinDCX',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/taxengine-crypto/images/1682491670_coinswitch.svg',
    name: 'CoinSwitch',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109376_binance_logo.png',
    name: 'Binance',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109827_coinbase_logo.png',
    name: 'Coinbase',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109384_bitbns_logo.png',
    name: 'BitBNS',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108721_zebpay__logo.png',
    name: 'Zebpay',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108642_metamask_logo.png',
    name: 'Metamask',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109568_etherium_logo.png',
    name: 'Etherium',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
];

export const itrData = {
  heroSection,
  isVariant: false,
  whyChooseSection,
};

export const GuidesAndLinksDataITR2 = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Income tax filing for capital gains',
      description: `ClearTax has integrations with 80+ brokers, enabling one-click fetching of capital gains data.`,
      link: 'https://cleartax.in/s/itr2',
    },
    {
      label: 'Types of capital gains income',
      description: `Learn about capital gains, its classification as short-term and long-term, and its taxation. Know about the various deductions available to save taxes on capital gains.`,
      link: 'https://cleartax.in/s/capital-gains-income',
    },
    {
      label: 'Set off & carry forward capital losses',
      description: `Understand how to treat capital losses and adjust them against gains to reduce taxable income.`,
      link: 'https://cleartax.in/s/set-off-carry-forward-capital-losses',
    },
    {
      label: 'ESOP & RSU Taxation',
      description: `ESOPs and RSUs have the same tax treatment. When either is sold, they are treated as capital gains and taxed at the applicable rates.`,
      link: 'https://cleartax.in/s/rsu-vs-esop-taxation',
    },
    {
      label: 'Long-term Capital Gains',
      description: `Gains from the transfer of long-term capital assets (held for more than either 12 or 24 months, as applicable) are known as long-term capital gains.`,
      link: 'https://cleartax.in/s/long-term-capital-gains-ltcg-tax',
    },
    {
      label: 'Short-term Capital Gains',
      description: `Gains from the transfer of short-term capital assets (held for less than either 12 or 24 months, as applicable) are known as short-term capital gains. `,
      link: 'https://cleartax.in/s/short-term-capital-gains-stcg-tax',
    },
    {
      label: 'LTCG & STCG Tax Rate on Shares',
      description: `LTCG from the sale of equity shares are taxed at a flat rate of rate of 12.5% exceeding Rs. 1.25 lakh. STCG from the sale of shares is taxed at a flat rate of 20%`,
      link: 'https://cleartax.in/s/taxation-on-income-earned-from-selling-shares',
    },
    {
      label: 'LTCG calculator',
      description: `Calculate your long-term capital gains based on the holding period of equity-oriented mutual funds and listed equity shares.`,
      link: 'https://cleartax.in/s/itr-filing-for-esop-and-rsu',
    },
  ],
};

export const ITR_2_FAQs = [
  {
    header: 'How are capital gains from ESOPs and RSUs taxed?',
    content: (
      <>
        <p>
          Capital gains taxation depends on the holding period and whether the
          shares are listed:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              Listed Shares: If held for more than 12 months, gains are
              considered long-term and taxed at 12.5% without indexation
              benefits and 1.25 lakhs exemption limit.
            </li>
            <li>
              Unlisted Shares: If held for more than 24 months, gains are
              considered long-term and taxed at 12.5% without indexation
              benefits.
            </li>
          </ul>
          <br />
          Short-term capital gains (held for less than the above periods) are
          taxed at applicable slab rates for unlisted shares and at 20% for
          listed shares.
        </p>
      </>
    ),
  },
  {
    header: 'Do I need to disclose foreign ESOPs or RSUs in my tax return?',
    content: (
      <p>
        Yes, if you are a resident Indian holding ESOPs or RSUs in foreign
        companies, you must disclose these under Schedule FA (Foreign Assets) in
        your Income Tax Return (ITR). Non-disclosure can attract penalties under
        the Black Money Act.
      </p>
    ),
  },
  {
    header: 'Can I claim tax relief for taxes paid in foreign countries?',
    content: (
      <p>
        Yes, India has Double Taxation Avoidance Agreements (DTAA) with several
        countries. If you&apos;ve paid taxes abroad on your ESOPs or RSUs, you
        can claim relief in India by filing Form 67 along with your ITR,
        provided you report the income in the same financial year.
      </p>
    ),
  },
  {
    header:
      "What if I don't have liquidity to pay taxes at the time of exercise or vesting?",
    content: (
      <p>
        This is a common concern, especially with unlisted companies where
        there&apos;s no immediate market to sell shares. Some startups allow
        deferring the tax payment until you sell the shares or after a specified
        period. Employees at the start-up would not have to pay the tax on the
        perk in the year in which they exercised the ESOP. TDS on ESOPS would be
        delayed until the sooner of the following dates:
        <br />
        <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
          <li>Five years from the date of the ESOP grant</li>
          <li>When the employee sells the ESOP</li>
          <li>Date of departure from the company</li>
        </ul>
      </p>
    ),
  },
  {
    header:
      'Are there penalties for late or incorrect tax filings related to ESOPs and RSUs?',
    content: (
      <p>
        Yes, failing to report income from ESOPs or RSUs, especially foreign
        holdings, can lead to penalties, interest on unpaid taxes, and scrutiny
        from tax authorities. It&apos;s crucial to maintain accurate records and
        file returns timely.
      </p>
    ),
  },
  {
    header: `How do I determine the Fair Market Value (FMV) of my shares?`,
    content: (
      <p>
        For listed companies, FMV is typically the average of the opening and
        closing prices on the stock exchange on the exercise or vesting date.
        For unlisted companies, a valuation by a SEBI-registered merchant banker
        is required to determine the FMV.
      </p>
    ),
  },
  {
    header: 'What documentation should I maintain for ESOPs and RSUs?',
    content: (
      <p>
        Keep the following records:
        <br />
        <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
          <li>
            Grant letters detailing the number of options or units granted.
          </li>
          <li>Vesting schedules. Exercise or vesting confirmations.</li>
          <li>Sale transaction statements.</li>
          <li>Tax deduction certificates (like Form 16).</li>
          <li>Valuation reports for unlisted shares.</li>
        </ul>
        These documents are essential for accurate tax filing and in case of any
        queries from tax authorities.
      </p>
    ),
  },
];
